<a [attr.href]="deckUrl">
    <div #containerOuter class="w-full flex flex-col text-faded-90 hover:text-white hover:cursor-pointer hover:font-bold text-sm rounded">
        <div #containerInner class="flex flex-row p-2 rounded">
            <div class="grow truncate">
                {{ deck.name }}
            </div>
        </div>
    </div>
</a>